import { ITopicQuestionAnswer } from "./../topic-question-answer/index";
import { ITopicQuestion } from "./../topic-question/index";
import { ITemplate } from "./../template/index";
import { IUser } from "./../user/index";
export interface ITopicUsers {
  id: number;
  role: string;
  status: string;
  score: number;
  user: IUser;
}

export enum PrivacyEnum {
  INVITATION = "invitation",
  FRIENDS = "friends",
  PUBLIC = "public",
}

export enum TopicStatus {
  WAITING = "waiting",
  IN_PROGRESS = "in-progress",
  COMPLETED = "completed",
  CANCELED = "cancelled",
}

export enum TopicSteps {
  PLAYERS_TO_JOIN = "players-to-join",
  ANSWERING = "answering",
  CREATOR_TO_VALIDATE = "creator-to-validate",
  CREATOR_TO_CONTINUE = "creator-to-continue",
  FINISHED = "finished",
}

export interface ITopic {
  id: number;
  templateId: number;
  creatorId: number;
  privacy: PrivacyEnum;
  status: TopicStatus;
  step: TopicSteps;
  startDate: Date;
  endDate: Date;
  users: ITopicUsers[];
  template: ITemplate;
  currentQuestion?: ITopicQuestion;
  topicQuestionConfig: {
    id: number;
    topicId: number;
    timer: number;
    questionsCount: number;
    completedQuestionsCount: number;
  };
  answers: ITopicQuestionAnswer[];
  createdAt: Date;
  updatedAt: Date;
  password?: string;
}
